import { render, staticRenderFns } from "./BaseButtonSelect.vue?vue&type=template&id=2c770e29&scoped=true&"
import script from "./BaseButtonSelect.vue?vue&type=script&lang=js&"
export * from "./BaseButtonSelect.vue?vue&type=script&lang=js&"
import style0 from "./BaseButtonSelect.vue?vue&type=style&index=0&id=2c770e29&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c770e29",
  null
  
)

export default component.exports